import { Navigate, Route, Routes } from 'react-router-dom'
import AuthPage from './Authentication'
import LoginPage from './Authentication/LoginPage'
import DashboardPage from './pages/DashboardPage'
import AnonymizerLayout from '../tools/anonymizer/AnonymizerLayout'
import DeadLetterLayout from '../tools/dead-letter/DeadLetterLayout'
import ErrorTrackerLayout from '../tools/error-tracker/ErrorTrackerLayout'
import CommandLayout from '../tools/command/CommandLayout'
import InvestigationLayout from '../tools/investigation/InvestigationLayout'
import KeyVaultLayout from '../tools/key-vault/KeyVaultLayout'
import ReleaseCheckLayout from '../tools/release-check/ReleaseCheckLayout'

const TopLevelRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/anonymizer/*" element={<AnonymizerLayout />} />
      <Route path="/dead-letter/*" element={<DeadLetterLayout />} />
      <Route path="/error-tracker/*" element={<ErrorTrackerLayout />} />
      <Route path="/command/*" element={<CommandLayout />} />
      <Route path="/investigation/*" element={<InvestigationLayout />} />
      <Route path="/key-vault/*" element={<KeyVaultLayout />} />
      <Route path="/release-check/*" element={<ReleaseCheckLayout />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="auth-page" element={<AuthPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default TopLevelRoutes
